import styled from "styled-components";

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const CheckboxTitle = styled.div`
  font-weight: bold;
  margin: 20px 0 0 5px;
`;